import makeStyles from '@mui/styles/makeStyles'

const useStyles = makeStyles(theme => ({
  container: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'space-around',

    '&:hover': {
      '& .icon': {
        color: theme.palette.primary.main
      },

      '& $check': {
        visibility: 'visible'
      },

      '& $title': {
        color: theme.palette.primary.main
      }
    }
  },

  root: {
    flex: '1',
    display: 'flex',
    alignItems: 'center',
    marginTop: '16px',
    width: '446px',
    paddingBottom: '16px'
  },

  rootMobile: {
    marginLeft: '1rem',
    minWidth: '0',
    width: 'calc(100vw - 2rem)',
    maxWidth: '100%',
    cursor: 'pointer'
  },

  avatar: {
    alignSelf: 'flex-start',
    marginRight: '16px'
  },

  content: {
    display: 'flex',
    flexBasis: '100%',
    flexDirection: 'column',
    justifyContent: 'center'
  },

  title: {
    marginBottom: '8px',
    fontSize: theme.size.base,
    color: '#1F1F1F'
  },

  clampWidth: {
    maxWidth: ({ onMobile }) => (onMobile ? 'calc(100vw - 5.5rem)' : '23rem'),
    whiteSpace: 'break-spaces'
  },

  stamp: {
    fontSize: theme.size.sm,
    color: '#8F8F8F'
  },

  check: {
    flexBasis: 28,
    visibility: 'hidden',
    alignSelf: 'flex-start'
  },

  separator: {
    marginLeft: 'auto',
    marginRight: 'auto',
    borderTop: '1px solid #F0F0F0',
    width: 'calc(100% - 48px)'
  },

  menu: {
    alignSelf: 'flex-start',
    height: 'max-content',
    width: 'max-content'
  }
}))

export default useStyles
